import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { $host, $oldHost } from 'shared/api/base/http';
import { RootState } from 'shared/lib/store/redux';

import {
  IGetGroupExamsScheduleQueryArgs,
  IGetGroupExamsScheduleResponse,
  IGetGroupScheduleQueryArgs,
  IGetGroupScheduleResponse,
  ISearchGroupsQueryArgs,
  ISearchGroupsResponse,
} from '../models/types';

export const searchGroups = createAsyncThunk(
  'groups/searchGroups',
  async ({ data }: ISearchGroupsQueryArgs, thunkApi) => {
    const state = thunkApi.getState() as RootState;
    const { token } = state.yaSmartCaptchaReducer;

    if (!token) {
      return thunkApi.rejectWithValue('Captcha verification required');
    }

    try {
      const res = await $host.get<ISearchGroupsResponse>(
        '/schedule_public/groups',
        {
          params: {
            query: data,
          },
          headers: {
            'Content-Type': 'application/json',
            'X-Captcha-Token': token,
          },
        },
      );
      return res.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error as AxiosError);
    }
  },
);

export const getGroupSchedule = createAsyncThunk(
  'groups/getGroupSchedule',
  async (
    { group, startDate, endDate }: IGetGroupScheduleQueryArgs,
    thunkApi,
  ) => {
    const state = thunkApi.getState() as RootState;
    const { token } = state.yaSmartCaptchaReducer;

    if (!token) {
      return thunkApi.rejectWithValue('Captcha verification required');
    }
    try {
      const res = await $host.get<IGetGroupScheduleResponse>(
        `/schedule_public/${group}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Captcha-Token': token,
          },
        },
      );
      res.data.result.startDate = startDate;
      res.data.result.endDate = endDate;
      return res.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error as AxiosError);
    }
  },
);

export const getGroupExamsSchedule = createAsyncThunk(
  'groups/getGroupExamsSchedule',
  async ({ group }: IGetGroupExamsScheduleQueryArgs, thunkApi) => {
    const state = thunkApi.getState() as RootState;
    const { token } = state.yaSmartCaptchaReducer;

    if (!token) {
      return thunkApi.rejectWithValue('Captcha verification required');
    }
    try {
      const res = await $oldHost.get<IGetGroupExamsScheduleResponse>(
        `/schedule_public/exam/${group}`,
      );
      return res.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error as AxiosError);
    }
  },
);
